import {LogService} from '@ispm/core/services/log.service';
import {Injectable} from "@angular/core";

@Injectable()
export class LogServiceHelper {

  public printLogs: boolean = false;

  constructor(private logService: LogService) {
  }

  public sendLog(className: string, effect: string, paramsObj?: any) {

    if (!this.printLogs) { return; }

    let logMsg: string = className + ' ' + effect + ' :';
    logMsg += JSON.stringify(paramsObj);
    console.log(logMsg);
    this.logService.info(logMsg, '');
  }

  public sendLog2(className: string, effect: string, paramsObj?: any[]) {

    if (!this.printLogs) { return; }

    let logMsg: string = className + ' ' + effect + ' :';
    paramsObj.forEach(obj => {
        logMsg += '\n' + JSON.stringify(obj);
      }
    );
    console.log(logMsg);
    this.logService.info(logMsg, '');
  }
}
